import React, { useState, useCallback } from 'react';
import Button from '@mui/material/Button';

/**
 * AsyncButton
 * - onClick may be an async function (returning a Promise) or sync.
 * - While the returned Promise is pending, the button is disabled.
 * - Props:
 *   - disableWith: optional label to show while loading (string or node)
 *   - onClick: function(event) -> maybe Promise
 *   - ...rest -> passed to MUI Button
 */
export default function AsyncButton({ disableWith, onClick, children, disabled: disabledProp, ...rest }) {
  const [loading, setLoading] = useState(false);

  const handleClick = useCallback(async (e) => {
    if (loading || disabledProp) return;
    setLoading(true);

    try {
      const result = onClick ? onClick(e) : null;
      if (result && typeof result.then === 'function') {
        await result;
      }
    } finally {
      setLoading(false);
    }
  }, [loading, disabledProp, onClick]);

  return (
    <Button
      {...rest}
      disabled={Boolean(disabledProp) || loading}
      onClick={handleClick}
    >
      {loading && typeof disableWith !== 'undefined' ? disableWith : children}
    </Button>
  );
}
